import styled from 'styled-components';

export const Container = styled.div`
  @supports not (
    (backdrop-filter: blur(50px)) or (-webkit-backdrop-filter: blur(50px))
  ) {
    background: #07021ae5;
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  height: 104px;
  padding: 0 15.625%;
  width: 100%;
  background: #2e0cae20 0% 0% no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  z-index: 3;

  @media (max-width: 960px) {
    justify-content: space-around;
    padding: 0;
  }
`;

export const Content = styled.div`
  display: flex;
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  margin-right: 36px;

  @media (max-width: 1024px) {
    margin-left: 10%;
  }

  @media (max-width: 960px) {
    margin-left: 2.5%;
    margin-right: 2.5%;
    width: 50%;
  }
`;

export const Image = styled.img`
  margin-right: 5px;
`;

export const Span = styled.span`
  font-size: 1.125rem;
  font-weight: 400;
  color: #ffffff;

  @media (max-width: 960px) {
    font-size: 4.1vw;
  }
`;
